import { DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import type { UseAgencyFormPayload } from '@hooks/useAgency'

interface AgencyAddressProps {
  agencyFormPayload: UseAgencyFormPayload,
}

const AgencyAddress = (props: AgencyAddressProps) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      address_line_1,
      address_line_2,
      address_postcode,
      address_region,
      address_state,
      geo_country_id,
    },
    errors,
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule title="Address">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.address_line_1} label="* Address Line 1">
            <input name="address_line_1" value={address_line_1} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Address Line 2" marginTop={['large', 0]}>
            <input name="address_line_2" value={address_line_2} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.address_region} label="* Suburb/Region">
            <input name="address_region" value={address_region} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.address_postcode} label="* Post Code" marginTop={['large', 0]}>
            <input name="address_postcode" value={address_postcode} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.address_state} label="* State">
            <input name="address_state" value={address_state} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.geo_country_id} label="* Country" marginTop={['large', 0]}>
            <EntitySelectBox
              data-value-type="number"
              entityKey="geoCountries"
              // @ts-expect-error TS2322
              name="geo_country_id"
              sortDirection="asc"
              sortKey="title"
              value={geo_country_id}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default AgencyAddress
